$(document).ready(function () {
  var first_time_count = $('.Ncop p').text();
  var temp_protine_count = $('.Ncop p').text();
  var temp_protine_text = $('.Ncop h2').text();

  $('.rk_description').append(
    "<div class='counter_portion_main' style='margin-top:20px;'><input type='hidden' id='first_portion_count' name='first_portion_count' value='" +
      first_time_count +
      "'><button class='cal_icon' aria-label='Anzahl Portionen verringern' onclick='reduce_to_count()'>-</button><input style='padding: 3px 8px;border: 2px solid #777;margin: 0px 8px; width:40px;' type='text' name='cal_no' id='cal_no' aria-label='Anzahl Portionen' value='" +
      temp_protine_count +
      "' readonly><button class='cal_icon' aria-label='Anzahl Portionen erhöhen' onclick='add_to_count()'>+</button> <span class='rk_meta'>" +
      temp_protine_text +
      '</span></div>'
  );

  $('.cook-slide-ingriedent-header').append(
    "<div class='counter_portion_main' style='margin-top:20px;'><input type='hidden' id='first_portion_count_slider' name='first_portion_count_slider' value='" +
      first_time_count +
      "'><button class='cal_icon' aria-label='Anzahl Portionen verringern' onclick='reduce_to_count_slider()'>-</button><input style='padding: 3px 8px;border: 2px solid #777;margin: 0px 8px; width:40px;' type='text' name='cal_no_slider' id='cal_no_slider' aria-label='Anzahl Portionen' value='" +
      temp_protine_count +
      "' readonly><button class='cal_icon' aria-label='Anzahl Portionen erhöhen' onclick='add_to_count_slider()'>+</button> <span class='rk_meta'>" +
      temp_protine_text +
      '</span></div>'
  );

  setTimeout(function () {
    $('.Ncop p').remove();
    $('.Ncop h2').remove();
  }, 500);
  replacehtml(first_time_count, temp_protine_count);
  replaceSliderHtml(first_time_count, temp_protine_count);
});

function add_to_count() {
  var total_temp_counts = parseInt($('#cal_no').val());
  var total_plus_temp_count = total_temp_counts + 1;
  $('#cal_no').val(total_plus_temp_count);
  var temp_count_incr = $('#first_portion_count').val();

  $('#first_portion_count').val(total_plus_temp_count);
  replacehtml(temp_count_incr, total_plus_temp_count);
}

function reduce_to_count() {
  var total_temp_counts = parseInt($('#cal_no').val());
  total_temp_counts = total_temp_counts - 1;
  if (total_temp_counts < 1) {
    total_temp_counts = 1;
  }
  $('#cal_no').val(total_temp_counts);
  var temp_count_decr = $('#first_portion_count').val();

  $('#first_portion_count').val(total_temp_counts);
  replacehtml(temp_count_decr, total_temp_counts);
}

function add_to_count_slider() {
  var total_temp_counts = parseInt($('#cal_no_slider').val());
  var total_plus_temp_count = total_temp_counts + 1;
  $('#cal_no_slider').val(total_plus_temp_count);
  var temp_count_incr = $('#first_portion_count_slider').val();

  $('#first_portion_count_slider').val(total_plus_temp_count);
  replaceSliderHtml(temp_count_incr, total_plus_temp_count);
}

function reduce_to_count_slider() {
  var total_temp_counts = parseInt($('#cal_no_slider').val());
  total_temp_counts = total_temp_counts - 1;
  if (total_temp_counts < 1) {
    total_temp_counts = 1;
  }
  $('#cal_no_slider').val(total_temp_counts);
  var temp_count_decr = $('#first_portion_count_slider').val();

  $('#first_portion_count_slider').val(total_temp_counts);
  replaceSliderHtml(temp_count_decr, total_temp_counts);
}

function replacehtml(portion, inputPortion) {
  $('.rk_ingredients li').each(function () {
    $(this).filter(function (index) {
      if ($('a', this).length > 0 && $('a', this).first().text().length > 0) {
        var first_digit = $.trim($('a', this).first().text().replace(/['"]+/g, '')).split(' ');

        if (Number(parseInt(first_digit[0])) === parseInt(first_digit[0])) {
          var def = myCustomCountFunction(portion, first_digit[0], inputPortion);
          $('a', this)
            .first()
            .text($('a', this).first().text().replace(first_digit[0], def.replace('.', ',')).replace(/['"]+/g, ''));
        }
      } else if ($('p', this).length > 0 && $('p', this).first().text().length > 0) {
        var first_digit = $.trim($('p', this).first().text().replace(/['"]+/g, '')).split(' ');

        if (Number(parseInt(first_digit[0])) === parseInt(first_digit[0])) {
          var def = myCustomCountFunction(portion, first_digit[0], inputPortion);
          $('p', this)
            .first()
            .text($('p', this).first().text().replace(first_digit[0], def.replace('.', ',')).replace(/['"]+/g, ''));
        }
      } else if ($('span', this).length > 0 && $('span', this).first().text().length > 0) {
        var first_digit = $.trim($('span', this).first().text().replace(/['"]+/g, '')).split(' ');
        if (Number(parseInt(first_digit[0])) === parseInt(first_digit[0])) {
          var def = myCustomCountFunction(portion, first_digit[0], inputPortion);
          $('span', this).text(
            $('span', this).text().replace(first_digit[0], def.replace('.', ',')).replace(/['"]+/g, '')
          );
        }
      } else if ($('strong', this).length > 0 && $('strong', this).first().text().length > 0) {
        var first_digit = $.trim($('strong', this).first().text().replace(/['"]+/g, '')).split(' ');

        if (Number(parseInt(first_digit[0])) === parseInt(first_digit[0])) {
          var def = myCustomCountFunction(portion, first_digit[0], inputPortion);
          $('strong', this)
            .first()
            .text($('strong', this).first().text().replace(first_digit[0], def.replace('.', ',')).replace(/['"]+/g, ''));
        }
      } else {
        var first_digit = $(this).text().replace(/['"]+/g, '').split(' ');

        if (Number(parseInt(first_digit[0])) === parseInt(first_digit[0])) {
          var def = myCustomCountFunction(portion, first_digit[0], inputPortion);
          $(this).text($(this).text().replace(first_digit[0], def.replace('.', ',')).replace(/['"]+/g, ''));
        }
      }
    });
  });
}

function replaceSliderHtml(portion, inputPortion) {
  $('.normal-recipe-product.slider-recipe-content').each(function () {
    var text = $(this).text().trim();
    var first_digit = text.split(' ')[0];

    if (Number(parseFloat(first_digit.replace(',', '.'))) === parseFloat(first_digit.replace(',', '.'))) {
      var def = myCustomCountFunction(portion, first_digit.replace(',', '.'), inputPortion);
      $(this).text(text.replace(first_digit, def.replace('.', ',')));
    }
  });
}

function myCustomCountFunction(defualtPortion, ingredients, inputPortion) {
  var newintval = ((ingredients.replace(',', '.') / defualtPortion) * inputPortion).toFixed(2);
  if (newintval < 0.1) {
    return 0.1;
  } else {
    var lastThirdChar = newintval.slice(-3);
    var lastDoubleChar = newintval.slice(-2);
    var lastOneChar = newintval.slice(-1);
    if (lastThirdChar == '000' || lastThirdChar == '.00') {
      newintval = newintval.slice(0, -3);
      return newintval;
    } else if (lastDoubleChar == '00' || lastDoubleChar == '.0') {
      newintval = newintval.slice(0, -2);
      if (newintval.slice(0, -1) == '.') {
        newintval = newintval.slice(0, -1);
        return newintval;
      } else {
        return newintval;
      }
    } else if (lastOneChar == '0' || lastOneChar == '.') {
      return newintval.slice(0, -1);
    } else {
      if (newintval.slice(0, -1) == '.') {
        newintval = newintval.slice(0, -1);
        return newintval;
      } else {
        return newintval;
      }
    }
  }
}